var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"must"},[_vm._t("default",function(){return [_c('b',[_vm._v("温馨提示:本游戏将在"+_vm._s(_vm.content)+"下架")]),_c('br'),_vm._v(" 版本待下架期间的新区不享受平台沙巴克奖励"),_c('br'),_vm._v(" 请您思考后慎重进行充值兑换 ")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }